import React from "react";
import { PaginatedResponse } from "src/types";

import { AnnouncementSubscriber, fetchSubscribers, FetchSubscribersPayload } from "@admin/api/announcements";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useFetchSubscribers = (payload?: FetchSubscribersPayload) => {
    const [data, setData] = React.useState<PaginatedResponse<AnnouncementSubscriber> | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);

    const refetch = React.useCallback(() => {
        setIsLoading(true);

        void fetchSubscribers(payload)
            .then((response) => setData(response))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
        // `payload` is a fresh object on every render, so depend on its fields. Keep this list in step with
        // FetchSubscribersPayload: the linter cannot check it here.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payload?.email, payload?.pageIndex, payload?.pageSize, payload?.sortCriteria, payload?.sortDirection]);

    React.useLayoutEffect(() => {
        refetch();
    }, [refetch]);

    return { data, isLoading, refetch };
};
